import { render, staticRenderFns } from "./GenderPanel.vue?vue&type=template&id=4c391c96&scoped=true"
import script from "./GenderPanel.vue?vue&type=script&lang=js"
export * from "./GenderPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c391c96",
  null
  
)

export default component.exports